export const devLabel = 'DEV VERSION';

export const checkAppVersionCompatibility = (
  appVersion: string,
  backendVersion: string,
) => {
  const [appMajor, appMinor, appPatch] = appVersion.split('.').map(Number);
  const [backendMajor, backendMinor, backendPatch] = backendVersion
    .split('.')
    .map(Number);

  return (
    appMajor === backendMajor &&
    appMinor <= backendMinor &&
    appPatch <= backendPatch
  );
};

export function getMajorVersion(text: string) {
  const m = text.match(/^(\d+)\./);
  return m ? Number(m[1]) : NaN;
}

export function isDevVersion(version: string) {
  const major = getMajorVersion(version);
  return major % 2 === 0;
}
